export const BreederIndexMockData = [
    {
        index: "1",
        name: "KLAWERVLEI",
        runners: "333",
        aepr: "R 42 234",
        runs: "1342",
        wnrs: "176",
        wins: "118",
        winnerRunPerc: "30%",
        swWinners: "1",
        swWins: "1",
        swPerWnrPerc: "1%",
        place: "345",
        placePerRnrPerc: "26%",
        sp: "4",
        topEarnerAndStake: "TWIN PEAKS R 1,400,000.00"
    },
    {
        index: "2",
        name: "CIRILLO",
        runners: "12",
        aepr: "R 15 983",
        runs: "132",
        wnrs: "176",
        wins: "209",
        winnerRunPerc: "2",
        swWinners: "3",
        swWins: "3%",
        swPerWnrPerc: "3%",
        place: "245",
        placePerRnrPerc: "31%",
        sp: "5",
        topEarnerAndStake: "PAVAROTTI PASSION R 1,202,000.00"
    },
    {
        index: "3",
        name: "CORAL FEVER",
        runners: "54",
        aepr: "R 15 983",
        runs: "751",
        wnrs: "176",
        wins: "157",
        winnerRunPerc: "3",
        swWinners: "4",
        swWins: "2%",
        swPerWnrPerc: "42%",
        place: "189",
        placePerRnrPerc: "34%",
        sp: "6",
        topEarnerAndStake: "DYLAN'S WORLD R 1,134,345.00"
    },
    {
        index: "4",
        name: "MAJESTIC MOZART",
        runners: "52",
        aepr: "R 78 093",
        runs: "221",
        wnrs: "653",
        wins: "91",
        winnerRunPerc: "5",
        swWinners: "2",
        swWins: "4%",
        swPerWnrPerc: "49%",
        place: "177",
        placePerRnrPerc: "21%",
        sp: "7",
        topEarnerAndStake: "GOLD CHALICE R 1,315,000.00"
    },
    {
        index: "5",
        name: "BYE BYE ROCKET",
        runners: "101",
        aepr: "R 42 234",
        runs: "426",
        wnrs: "",
        wins: "189",
        winnerRunPerc: "6",
        swWinners: "1",
        swWins: "1%",
        swPerWnrPerc: "62%",
        place: "165",
        placePerRnrPerc: "12%",
        sp: "2",
        topEarnerAndStake: "NORTHERN FLYER R 1,400,000.00"
    },
    {
        index: "6",
        name: "DAWN ASSAULT",
        runners: "178",
        aepr: "R 15 983",
        runs: "132",
        wnrs: "101",
        wins: "112",
        winnerRunPerc: "3",
        swWinners: "2",
        swWins: "2%",
        swPerWnrPerc: "52%",
        place: "143",
        placePerRnrPerc: "18%",
        sp: "1",
        topEarnerAndStake: "YESAN STAR R 900,000.00"
    },
    {
        index: "7",
        name: "CASCAPEDIA",
        runners: "234",
        aepr: "R 78 093",
        runs: "426",
        wnrs: "176",
        wins: "281",
        winnerRunPerc: "3",
        swWinners: "1",
        swWins: "4%",
        swPerWnrPerc: "15%",
        place: "165",
        placePerRnrPerc: "22%",
        sp: "4",
        topEarnerAndStake: "MR TINSEL R 1,562,000.00"
    },
    {
        index: "8",
        name: "DAN THE LAD",
        runners: "142",
        aepr: "R 42 234",
        runs: "243",
        wnrs: "132",
        wins: "291",
        winnerRunPerc: "4",
        swWinners: "3",
        swWins: "5%",
        swPerWnrPerc: "28%",
        place: "215",
        placePerRnrPerc: "27%",
        sp: "6",
        topEarnerAndStake: "MOVIE SHOW R 1,050,210.00"
    },
    {
        index: "9",
        name: "AFRICA RISING",
        runners: "3",
        aepr: "R 15 983",
        runs: "132",
        wnrs: "176",
        wins: "134",
        winnerRunPerc: "7",
        swWinners: "2",
        swWins: "2%",
        swPerWnrPerc: "45%",
        place: "434",
        placePerRnrPerc: "45%",
        sp: "2",
        topEarnerAndStake: "CRIMEAN QUEEN R 1,187,000.00"
    },
    {
        index: "10",
        name: "HAWWAAM",
        runners: "143",
        aepr: "R 78 093",
        runs: "426",
        wnrs: "273",
        wins: "78",
        winnerRunPerc: "5",
        swWinners: "4",
        swWins: "3%",
        swPerWnrPerc: "35%",
        place: "354",
        placePerRnrPerc: "49%",
        sp: "5",
        topEarnerAndStake: "ON YOUR LIFE R 1,678,043.00"
    }
];